// // App.js
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Login from './pages/Login';
// import Register from './pages/Register';
// import DashboardPage from './pages/DashboardPage';
// import PackageForm from './components/PackageForm';
// import ViewPackages from './components/ViewPackages';
// import ManageFormFields from './components/ManageFormFields';
// import Dashboard from './components/Dashboard';
// import EditPackage from './components/EditPackage';
// import ManageUsers from './components/ManageUsers';
// import CreateUser from './components/CreateUser';
// import UpdateUser from './components/UpdateUser';
// import EmailAction from './pages/EmailAction';
// import PublicViewCosting from './components/PublicViewCosting';
// import ResetPassword from './pages/ResetPassword';

// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* Public Routes - No Login Required */}

//         <Route path="/public-view/:refId" element={<PublicViewCosting />} />

//         {/* CORRECT ROUTE FOR EMAIL APPROVAL LINKS */}
//         <Route path="/email-action/:refId" element={<EmailAction />} />

//         {/* Password Reset Route */}
//         <Route path="/reset-password/:token" element={<ResetPassword />} />

//         {/* Auth Routes */}
//         <Route path="/login" element={<Login />} />
//         <Route path="/register" element={<Register />} />

//         {/* Protected Dashboard Routes */}
//         <Route path="/dashboard/*" element={<DashboardPage />}>
//           <Route index element={<Dashboard />} />
//           <Route path="fill-package" element={<PackageForm />} />
//           <Route path="view-packages" element={<ViewPackages />} />
//           <Route path="manage-form" element={<ManageFormFields />} />
//           <Route path="edit-package/:refId" element={<EditPackage />} />
//           <Route path="users" element={<ManageUsers />} />
//           <Route path="users/create" element={<CreateUser />} />
//           <Route path="users/update/:id" element={<UpdateUser />} />
//         </Route>

//         {/* Default Route */}
//         <Route path="/" element={<Login />} />

//         {/* Fallback */}
//         <Route path="*" element={<Login />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;
// App.js
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import DashboardPage from './pages/DashboardPage';
import PackageForm from './components/PackageForm';
import ViewPackages from './components/ViewPackages';
import ManageFormFields from './components/ManageFormFields';
import Dashboard from './components/Dashboard';
import EditPackage from './components/EditPackage';
import ManageUsers from './components/ManageUsers';
import CreateUser from './components/CreateUser';
import UpdateUser from './components/UpdateUser';
import EmailAction from './pages/EmailAction';
import ResetPassword from './pages/ResetPassword';

// ✅ Separate component to access useLocation inside Router context
function AppRoutes() {
  const location = useLocation();

  return (
    <Routes location={location} key={location.pathname}>
      <Route path="/email-action/:refId" element={<EmailAction />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      <Route path="/dashboard/*" element={<DashboardPage />}>
        <Route index element={<Dashboard />} />
        <Route path="fill-package" element={<PackageForm />} />
        <Route path="view-packages" element={<ViewPackages />} />
        <Route path="manage-form" element={<ManageFormFields />} />
        <Route path="edit-package/:refId" element={<EditPackage />} />
        <Route path="users" element={<ManageUsers />} />
        <Route path="users/create" element={<CreateUser />} />
        <Route path="users/update/:id" element={<UpdateUser />} />
      </Route>

      <Route path="/" element={<Login />} />
      <Route path="*" element={<Login />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;